<div class="position-relative">
  @if (configService?.isLoaded) {
  <button class="btn btn-outline-primary create-pod-button" (click)="openAddPOD()">
    <i class="fa fa-lg fa-circle-plus"></i> {{ 'POD' | translate }}
  </button>
  }

  <lib-filter-list [configService]="configService"></lib-filter-list>
</div>
